import React from 'react';
import PropTypes from 'prop-types';
import Table from 'cccisd-graphql-table';
import IconSmile from 'cccisd-icons/smile';
import IconSad from 'cccisd-icons/wondering';
import _round from 'lodash/round';

const SummaryTable = props => {
    const _renderDataFace = value => {
        if (value < props.targetScore) {
            return (
                <>
                    <span style={{ color: 'red' }}>
                        <IconSad spaceRight />
                    </span>
                    {value}
                </>
            );
        }
        return (
            <>
                <span style={{ color: '#3673b6' }}>
                    <IconSmile spaceRight />
                </span>
                {value}
            </>
        );
    };

    const columns = [
        { name: 'group.label', label: 'Group Name', sort: true },
        {
            name: 'childRoles.metricspawn.assignmentProgressSummary.lastSessionHeld',
            label: 'Current Session',
            sort: true,
        },
        {
            name: 'childRoles.metricspawn.assignmentProgressSummary.facilitatorFidelityScoreAvg',
            label: 'Average Fidelity',
            sort: true,
            render: ({ value }) => _renderDataFace(_round(value, 1)),
        },
        {
            name: 'childRoles.metricspawn.assignmentProgressSummary.FidelityFoundationlElementsScoreAvg',
            label: 'Average Foundational Elements',
            sort: true,
            render: ({ value }) => _renderDataFace(_round(value, 1)),
        },
        {
            name: 'childRoles.metricspawn.assignmentProgressSummary.FidelityLeadershipScoreAvg',
            label: 'Average Leadership & Group Process',
            sort: true,
            render: ({ value }) => _renderDataFace(_round(value, 1)),
        },
    ];

    return (
        <Table
            rowKey="group.groupId"
            query={props.query}
            graphqlVariables={{
                groupIds: props.filters.groupIds,
                startDate: props.filters.startDate,
                endDate: props.filters.endDate,
            }}
            columns={columns}
            // render={tableProps => console.log(tableProps)}
        />
    );
};

SummaryTable.propTypes = {
    settings: PropTypes.object,
    isPreview: PropTypes.bool,
    filters: PropTypes.object,
    query: PropTypes.object,
    targetScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

SummaryTable.defaultProps = {
    filters: {},
};

export default SummaryTable;
